import { createTheme, MantineColorsTuple } from '@mantine/core';

// Holloway Brand Colors — Blue palette
const hollowayPrimary: MantineColorsTuple = [
  '#e8edf5',  // 0 lightest
  '#c5d0e5',  // 1
  '#a1b3d5',  // 2
  '#7e96c5',  // 3
  '#5e7db5',  // 4
  '#415a91',  // 5 primary
  '#374d7d',  // 6
  '#2d4069',  // 7
  '#233355',  // 8
  '#1a2641',  // 9 darkest
];

const hollowaySecondary: MantineColorsTuple = [
  '#edf2f8',  // 0
  '#d3deee',  // 1
  '#b9cae4',  // 2
  '#9fb6da',  // 3
  '#8ba7d0',  // 4
  '#7897c3',  // 5 secondary
  '#6681aa',  // 6
  '#546b91',  // 7
  '#425578',  // 8
  '#303f5f',  // 9
];

const hollowayTertiary: MantineColorsTuple = [
  '#eff6fa',  // 0
  '#d7eaf2',  // 1
  '#bfdee9',  // 2
  '#a7d2e1',  // 3
  '#98c1d9',  // 4
  '#83afc9',  // 5 tertiary
  '#6e9db9',  // 6
  '#5a8ba8',  // 7
  '#467998',  // 8
  '#326788',  // 9
];

const hollowayNeutral: MantineColorsTuple = [
  '#f2f4f7',  // 0 background
  '#e4e7ed',  // 1
  '#d0d5de',  // 2
  '#bcc3cf',  // 3
  '#a8b1c0',  // 4
  '#8e99ab',  // 5
  '#6b7a8e',  // 6
  '#4e5a6b',  // 7
  '#3a4452',  // 8
  '#2a3140',  // 9
];

export const hollowayTheme = createTheme({
  primaryColor: 'hollowayPrimary',
  
  colors: {
    hollowayPrimary,
    hollowaySecondary,
    hollowayTertiary,
    hollowayNeutral,
  },

  fontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily: '"Roboto Condensed", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },

  defaultRadius: 'md',
  
  primaryShade: 5,

  other: {
    brand: {
      primary: '#415A91',
      secondary: '#7897C3',
      tertiary: '#98C1D9',
      neutral: '#F2F4F7',
    },
  },

  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 500,
        },
      },
    },

    TextInput: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        input: {
          backgroundColor: '#F2F4F7',
          borderColor: '#D0D5DE',
          '&:focus': {
            borderColor: '#415A91',
          },
        },
      },
    },

    Textarea: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        input: {
          backgroundColor: '#F2F4F7',
          borderColor: '#D0D5DE',
          '&:focus': {
            borderColor: '#415A91',
          },
        },
      },
    },

    Select: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        input: {
          backgroundColor: '#F2F4F7',
          borderColor: '#D0D5DE',
          '&:focus': {
            borderColor: '#415A91',
          },
        },
      },
    },

    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
      styles: {
        root: {
          backgroundColor: '#FFFFFF',
          border: '1px solid #D0D5DE',
        },
      },
    },

    Paper: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    Modal: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        content: {
          backgroundColor: '#FFFFFF',
        },
      },
    },

    AppShell: {
      styles: {
        main: {
          backgroundColor: '#F2F4F7',
        },
      },
    },
  },
});
